import { userAPI } from 'entities/user';
import { AppThunk } from 'store';
import { batch } from 'react-redux';
import { getAnonymousUserId } from 'common/utils/anonymousUser';
import { isAutorizedUser } from 'common/utils/userTypes';
import { getResponseError } from 'common/utils/index';
import { STATUS_LOADING } from 'common/constants/statusLoading';
import { Permissions } from 'entities/user';

import slice from '../reducer/slice';
import { TUserType } from '../types';
import { applicationActions } from 'entities/application';

const { setPermissions, setPermissionsLoadingStatus } = slice.actions;
const { setErrorNotice } = applicationActions;

type TOperation = (userType: TUserType) => AppThunk;

const operations: TOperation = (userType) => async (dispatch) => {
  try {
    dispatch(setPermissionsLoadingStatus(STATUS_LOADING.load));

    let data: Permissions;
    if (isAutorizedUser(userType)) {
      const permissions = await userAPI.getPermissions();
      data = permissions.data;
    } else {
      const permissions = await userAPI.getAnonymousPermissions(getAnonymousUserId());
      data = permissions.data;
    }
    
    batch(() => {
      dispatch(setPermissionsLoadingStatus(STATUS_LOADING.done));
      // @ts-ignore
      dispatch(setPermissions(data.data.permissions));
    });
  } catch (e) {
    const error = await getResponseError(e);
    batch(() => {
      dispatch(setErrorNotice(error));
      dispatch(setPermissionsLoadingStatus(STATUS_LOADING.error));
    });
  }
};

export default operations;
